import { LUCENE_THEME, SQLITE_THEME, YARA_THEME } from './themes';
import { BaseCodeEditorOptions } from '@nirvana/shared/code-editor';

export const THEMES = {
  luceneTheme: LUCENE_THEME,
  sqliteTheme: SQLITE_THEME,
  yaraTheme: YARA_THEME,
};

export enum SearchEvents {
  RUN_QUERY = 'runQuery',
  HELP_FOR_QUERY_ON_CLICK = 'helpForQueryOnClick',
}

export interface QueryError {
  from: number;
  to: number;
  type: string;
}

export const DEFAULT_CODE_EDITOR_OPTIONS: BaseCodeEditorOptions = {
  language: 'lucene',
  editorOptions: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: '300',
    fontSize: 12,
    lineHeight: 20,
    wrappingIndent: 'none',
    inlineSuggest: {
      enabled: false,
    },
    scrollBeyondLastLine: false,
    suggestFontSize: 12,
    scrollbar: {
      vertical: 'visible',
    },
    suggestLineHeight: 24,
    automaticLayout: true,
    fixedOverflowWidgets: false,
    theme: 'luceneTheme',
    wrappingStrategy: 'advanced',
    wordWrap: 'on',
    minimap: {
      enabled: false,
    },
    padding: {
      top: 4,
      bottom: 0,
    },
    contextmenu: false,
    hideCursorInOverviewRuler: true,
    glyphMargin: false,
    folding: false,
    overviewRulerBorder: false,
    smoothScrolling: true,
    overviewRulerLanes: 0,
    lineDecorationsWidth: 0,
    lineNumbersMinChars: 0,
    renderLineHighlight: 'none',
    lineNumbers: 'off',
    value: `other.event_name:*`,
    wordBasedSuggestions: false,
    suggestSelection: 'first',
    hover: {
      above: false,
    },
    quickSuggestions: {
      strings: true,
      other: true,
      comments: true,
    },
  },
  languageOptions: {
    validate: true,
    autoComplete: true,
    hover: true,
  },
};
